export const API_BASE_URL = "https://api.megaraonline.com/api";
export const API_SYNC_BASE_URL = API_BASE_URL;